import React from "react";
import { useRouteError } from "react-router-dom";
import Bugsnag from "@bugsnag/js";
import { errorLog } from "./utils/logger";
import { useTranslation } from "react-i18next";

export function ErrorPage() {
  const { t } = useTranslation();
  const error: any = useRouteError();
  errorLog(error as Error);
  Bugsnag.notify(error);

  const errorImg = "/assets/images/error_centered.png";

  return (
    <div
      id="error-page"
      data-testid="static-error-page"
      className="flex items-center justify-center min-h-screen"
      style={{
        backgroundImage: `url(${errorImg})`,
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "100vh",
        width: "100vw",
      }}
    >
      <div className="text-center px-8 mt-20" style={{ color: "#1a4d6e", maxWidth: "600px" }}>
        <p className="mb-1 mt-20" style={{ fontSize: "clamp(1rem, 3.5vw, 1.25rem)" }}>
          Docket wasn't immunized
        </p>
        <p className="mb-6" style={{ fontSize: "clamp(1rem, 3.5vw, 1.25rem)" }}>
          against this unknown error.
        </p>
        <p style={{ fontSize: "clamp(0.9rem, 3vw, 1.1rem)" }}>Please refresh the page</p>
        <p style={{ fontSize: "clamp(0.9rem, 3vw, 1.1rem)" }}>or restart the app.</p>
      </div>
    </div>
  );
}

export default ErrorPage;
